import BaseService from "../BaseService";
import _ from "lodash";

class CollaboratorUser extends BaseService {
    list = async (filter = {}) => {
        var data = await this._api.post("/collaboratoruser/list", filter);
        return data;
    };
    get = async (id) => {
        var data = await this._api.post("/collaboratoruser/get", { id });
        return data;
    };

    withdraw = async (id, amount) => {
        var data = await this._api.post("/collaboratoruser/withdraw", { id, amount });
        return data;
    };
    getTransactions = async (id) => {
        var data = await this._api.post("/collaboratoruser/gettransactions", { id });
        return data;
    };


    deleteTransaction = async (id) => {
        var data = await this._api.post("/collaboratoruser/deletetransaction", { id });
        return data;
    };

}
export default CollaboratorUser;
